// Pure helpers for the unified per-cave roll playlist (ADR 0254, LSC-619).

/** Slot label for a 0-based playback index: A…Z, then AA, AB… (bijective base 26),
 *  so only VISIBLE items get labels and they're always gap-free. */
export function rollSlotLabel(index: number): string {
  let n = index + 1;
  let out = "";
  while (n > 0) {
    const r = (n - 1) % 26;
    out = String.fromCharCode(65 + r) + out;
    n = Math.floor((n - 1) / 26);
  }
  return out;
}

/** Move `id` one step (delta = -1 up / +1 down); a no-op at either end. */
export function moveRollId(order: string[], id: string, delta: number): string[] {
  const i = order.indexOf(id);
  const j = i + delta;
  if (i < 0 || j < 0 || j >= order.length) return order;
  const next = order.slice();
  [next[i], next[j]] = [next[j], next[i]];
  return next;
}

/** Drag-and-drop: move `dragged` into `target`'s slot (items between shift by one).
 *  A no-op when either id is unknown or they're the same. */
export function dropRollId(order: string[], dragged: string, target: string): string[] {
  const from = order.indexOf(dragged);
  const to = order.indexOf(target);
  if (from < 0 || to < 0 || from === to) return order;
  const next = order.slice();
  next.splice(from, 1);
  next.splice(to, 0, dragged);
  return next;
}
